import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { userHasPermission } from '../../../authorisation/permission';
import { EmptyPlaceholder } from '../../../shared/EmptyPlaceholder';
import { Table, TBody, Th, THead, Tr } from '../../../shared/Table';
import { UserContext } from '../../../users/UserContext';
import { DesignResponse } from '../../projects/projectQuotesAndDesignsResponse';
import { ProjectDesignRow } from './ProjectDesignRow';

type Props = {
  projectId: number;
  designs: Array<DesignResponse>;
  refreshDesigns: () => void;
};

export const ProjectDesigns = ({ projectId, designs, refreshDesigns }: Props) => {
  const userCanEditDesigns = userHasPermission({ user: useContext(UserContext).getUser(), permission: 'Edit' });

  if (designs.length === 0) {
    return <EmptyPlaceholder message="No Designs have been created for this Project yet." />;
  }

  return (
    <ProjectDesignsTable>
      <THead>
        <Tr>
          <NameHeaderCell>Design Title</NameHeaderCell>
          <ComponentsHeaderCell>Components</ComponentsHeaderCell>
          <DesignReferencesHeaderCell colSpan={3} />
          <DateHeaderCell>Created</DateHeaderCell>
          <CreatedByHeaderCell>Created By</CreatedByHeaderCell>
          <DateHeaderCell>Uploaded</DateHeaderCell>
          <ActionsHeaderCell />
        </Tr>
      </THead>
      <TBody>
        {designs.map(design => (
          <ProjectDesignRow
            key={design.designId}
            projectId={projectId}
            design={design}
            userCanEditDesigns={userCanEditDesigns}
            refreshDesigns={refreshDesigns}
          />
        ))}
      </TBody>
    </ProjectDesignsTable>
  );
};

const ProjectDesignsTable = styled(Table)`
  width: 100%;
  table-layout: fixed;
`;

const NameHeaderCell = styled(Th)`
  width: 60%;
`;

const ComponentsHeaderCell = styled(Th)`
  width: 100px;
`;

const DesignReferencesHeaderCell = styled(Th)`
  width: 310px;
`;

const CreatedByHeaderCell = styled(Th)`
  width: 40%;
`;

const DateHeaderCell = styled(Th)`
  width: 125px;
`;

const ActionsHeaderCell = styled(Th)`
  width: 60px;
`;
